import { useSyncExternalStore } from 'react';

/**
 * @param {string} query e.g. "(min-width: 768px)"
 * @param {boolean} [serverFallback=false]
 */
export function useMediaQuery(query, serverFallback = false) {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : serverFallback),
    () => serverFallback,
  );
}

/** md breakpoint (768px) and up */
export function useIsDesktop() {
  return useMediaQuery('(min-width: 768px)', true);
}
